export const CART_KEY = 'sitecore-discover-cart';
export const CART_ADD_PRODUCT = 'ADD_PRODUCT';
export const CART_REMOVE_PRODUCT = 'REMOVE_PRODUCT';
export const CART_UPDATE_PRODUCT = 'UPDATE_PRODUCT';
export const CART_CLEAR = 'CLEAR_CART';

export const WISHLIST_KEY = 'sitecore-discover-wishlist';
export const WISHLIST_ADD_PRODUCT = 'WISHLIST_ADD_PRODUCT';
export const WISHLIST_REMOVE_PRODUCT = 'WISHLIST_REMOVE_PRODUCT';
export const WISHLIST_CLEAR = 'WISHLIST_CLEAR_CART';

export const NOTIFICATION_PROPS = {
  insert: 'top',
  container: 'top-right',
  animationIn: ['animate__animated', 'animate__fadeIn'],
  animationOut: ['animate__animated', 'animate__fadeOut'],
  dismiss: {
    duration: 3000,
  },
};

export const DUMMY_USER = {
  email: 'user@mail.com',
  id: 'd66bc7f21140430d0b207',
};
